import React from "react";
import "../../style/news/visitNGO.css";
import Comment from "../shared/Comment/Comment";
import Footer from "../shared/Footer/Footer";
import Navbar from "../shared/Navbar/Navbar";
import One from "../../images/Blogs-photo/16.02.2026/1.jpeg";
import Two from "../../images/Blogs-photo/16.02.2026/2.jpg";
import Three from "../../images/Blogs-photo/16.02.2026/3.jpg";
import Four from "../../images/Blogs-photo/16.02.2026/4.jpg";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";
import { useEffect } from "react";
import TranslateButton from "../TranslateButton/TranslateButton";

const VisitNGO = () => {
  useEffect(() => {
    document.title = `AshroyAngon | Official Visit of the Deputy Director of Local Government Division to Ashroy Angon Society, Rangamati `;
  }, []);

  const shareUrl =
    "https://ashroyangon.org/Official-visit-of-the-Deputy-Director";

  return (
    <>
      <Navbar />
      <TranslateButton />

      <div className="visit_deputy_director_section">
        <div className="blog_title">
          <div className="container">
            <h6>
              Official Visit of the Deputy Director of Local Government Division to Ashroy Angon Society, Rangamati
            </h6>
            <h2>
              Official Visit of the Deputy Director of Local Government Division to Ashroy Angon Society, Rangamati
            </h2>
            <h3>February 16, 2026</h3>
          </div>
        </div>
        <div className="image_part">
          <div className="header_image"></div>
          {/* Social Share Section Start */}
          <div className="social_share_wrapper">
            <div className="container">
              <div className="social_share_button">
                <FacebookShareButton
                  url={shareUrl}
                  target={"_blank"}
                  quote={"share facebook"}
                  hashtag={"#facebook"}
                >
                  <FacebookIcon size={35} round={true} />
                </FacebookShareButton>
                <TwitterShareButton
                  url={shareUrl}
                  target={"_blank"}
                  quote={"share twitter"}
                  hashtag={"#twitter"}
                >
                  <TwitterIcon size={35} round={true} />
                </TwitterShareButton>
                <LinkedinShareButton
                  url={shareUrl}
                  target={"_blank"}
                  quote={"share linkedin"}
                  hashtag={"#linkedin"}
                >
                  <LinkedinIcon size={35} round={true} />
                </LinkedinShareButton>
              </div>
            </div>
          </div>
          {/* Social Share Section End */}
        </div>
        <div className="content_wrapper">
          <div className="container">

            <div className="article">
              <p>Today, the current Deputy Director of the Local Government Division in Rangamati Hill District, Md. Mobarak Hossain, paid an official visit to our NGO, Ashroy Angon Society, located in Rangamati. The visit was conducted in a cordial and professional environment, with the honorable members of our Executive Committee (EC Committee) present to welcome and engage with the guest. The occasion provided an important opportunity to showcase the organization’s institutional activities and governance practices. </p>
              <p>At the beginning of the visit, our Manager (HRAPL), Shubra Pradip Khisa, delivered a comprehensive presentation using a projector. The presentation highlighted the organization’s background, mission, and strategic interventions, along with an overview of its major achievements and operational approaches. It effectively outlined how the organization has been contributing to community development through need-based and sustainable initiatives.</p>
              <p>During the inspection, the Deputy Director expressed keen interest in learning about both the current and past projects implemented by Ashroy Angon Society. He inquired in detail about various development programs, particularly those related to women’s empowerment, child rights, livelihood development, and support for disadvantaged communities. The concerned officials provided relevant data, field experiences, and progress updates, ensuring a clear and transparent understanding of the organization’s work.</p>
              <p>At the end of the visit, the Deputy Director appreciated the ongoing efforts and impact of the organization in the region. He emphasized the importance of continued coordination with the Local Government Division to strengthen development outcomes in the hill district. The visit concluded on a positive note, serving as an encouraging and motivating experience for the entire organization to further enhance its commitment to sustainable and inclusive community development.</p>
            </div>

            <div className="extra_image">
              <img src={One} loading="lazy" alt="" />
              <img src={Two} loading="lazy" alt="" />
              <img src={Three} loading="lazy" alt="" />
              <img src={Four} loading="lazy" alt="" />
            </div>

            <button>
              <a
                href="/all-blogs"
                target={"_blank"}
                id="style-2"
                data-replace="More Blogs"
              >
                <span>More Blogs</span>
              </a>
            </button>
          </div>
        </div>
      </div>

      {/* Comment Section */}
      <Comment />
      <Footer />
    </>
  );
};

export default VisitNGO;
